import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SchoolBellEAPIService } from './api-generated/member-picker-api';
import type { ConfirmMemberPickerSessionDto, MemberPickerSessionContextDto } from './api-generated/models';
export type { MemberPickerSessionContextDto, ConfirmMemberPickerSessionDto };

// 팝업/iframe 공용 최소 API 헬퍼 — 앱의 전역 API 클라이언트(자체 로그인 세션 Bearer 토큰을 모든
// 요청에 자동으로 붙이는 인터셉터)는 재사용하지 않는다. 이 code 기반 무인증 경로는 인증 모델
// 자체가 다르다(code 자체가 자격증명 — 2026-08-03 플랜 설계 결정 5). 섞어 쓰면 세션 토큰이
// 실수로 붙거나, 반대로 이 경로의 무인증 의도가 흐려진다. orval이 만든 SchoolBellEAPIService는
// base URL 없이 상대경로만 내므로, MEMBER_PICKER_API_BASE_URL을 붙이는 건
// memberPickerApiBaseUrlInterceptor(member-picker-config lib)가 담당한다.
@Injectable({ providedIn: 'root' })
export class MemberPickerApiService {
  private readonly api = inject(SchoolBellEAPIService);

  getSessionContext(code: string): Promise<MemberPickerSessionContextDto> {
    return firstValueFrom(this.api.memberPickerControllerGetSessionContext(code));
  }

  confirmSession(code: string, body: ConfirmMemberPickerSessionDto): Promise<void> {
    return firstValueFrom(this.api.memberPickerControllerConfirmSession(code, body));
  }
}
